import { render } from "./PermanentCandidates.listItem.vue?vue&type=template&id=9fc78a9a"
import script from "./PermanentCandidates.listItem.vue?vue&type=script&lang=js"
export * from "./PermanentCandidates.listItem.vue?vue&type=script&lang=js"

import "./PermanentCandidates.listItem.vue?vue&type=style&index=0&id=9fc78a9a&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QItem,QItemSection,QIcon,QItemLabel,QBtn,QTooltip});
